const Dashboard = () => {
  return <div className="text-4xl text-container">Dashboard</div>;
};

export default Dashboard;
